import { UserInfo } from "../../../models";
import { OrganizationModel, ODataResponse, ProvinceModel  } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";

export class OrganizationRepo extends BaseDataRepository<OrganizationModel>  {
  protected baseUrl = 'organization';

  async getUsers(id: number): Promise<ODataResponse<UserInfo>> {
    const url = `/OData/Organizations(${id})/Users`;

    const response = await this.client.get(url);
    return this.handleResponse(response);
  }

  async getAllProvinces() {
    const url = `Organization/Regions`

    const response = await this.client.get(url);
    return this.handleResponse<ProvinceModel>(response);
  }
}

export default OrganizationRepo;
